import { render } from "./HelpCenterBanner.vue?vue&type=template&id=6f31417d&scoped=true"
import script from "./HelpCenterBanner.vue?vue&type=script&lang=js"
export * from "./HelpCenterBanner.vue?vue&type=script&lang=js"

import "./HelpCenterBanner.vue?vue&type=style&index=0&id=6f31417d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f31417d"]])

export default __exports__